














import { defineComponent, ref, PropType, computed, watch, useFetch, onMounted } from '@nuxtjs/composition-api';
import { debounce } from 'lodash-es';
import AppSeeMoreButton from '~/components/partials/App/AppSeeMoreButton.vue';
import ContentRelatedItem from '~/components/partials/Content/ContentRelatedItem.vue';
import { useListFavorite } from '~/composables/contents/useListFavorite';
import { useStore } from '~/composables/useStore';
import { DISPLAY_ITEMS_NUM } from '~/constants';
import { RelatedItems } from '~/types/modules/contents';
import { ProductListItem } from '~/types/modules/product';
import { FavoriteTypes } from '~/enums';

export default defineComponent({
  components: {
    ContentRelatedItem,
    AppSeeMoreButton,
  },
  props: {
    item: {
      type: Object as PropType<RelatedItems>,
      required: true,
    },
  },
  setup(props) {
    const totalDisplayNum = ref(DISPLAY_ITEMS_NUM);
    const store = useStore();
    const { fetchAllFavorites } = useListFavorite();
    // ページネーション
    const pagination = ref(1);
    // 商品データ
    const products = ref<Array<ProductListItem>>([]);
    const authenticated = ref(store.state.auth.authenticated);

    useFetch(async () => {
      if (products.value.length) return;

      await fetchProducts();
    });

    watch(
      pagination,
      debounce(async () => await fetchProducts(), 100)
    );

    const requestCodes = computed(() => {
      const { related_product_codes } = props.item;
      return related_product_codes.slice(0, pagination.value * DISPLAY_ITEMS_NUM);
    });

    /**
     * 商品取得
     */
    const fetchProducts = async () => {
      const searchQueryCondition = requestCodes.value
        .map((productCode: string) => `product_code_s: ${productCode}`)
        .join(' OR ');
      const searchQuery = `mst:product AND (${searchQueryCondition}) NOT display_flag_i: 0`;

      const { items } = await store.dispatch('modules/product/fetchProducts', {
        q: searchQuery,
      });

      products.value = items;
    };

    // もっと見るボタンの表示・非表示
    const isLoadMoreButtonVisible = computed(() => {
      const { related_product_codes } = props.item;
      return pagination.value * DISPLAY_ITEMS_NUM < related_product_codes.length;
    });

    onMounted(async () => {
      fetchAllFavorites(FavoriteTypes.ITEM);

      if (!authenticated.value) return;
      try {
        await store.dispatch('modules/lottery/fetchLotteryApplications', {
          query: { is_applying: true },
        });
      } catch {
        // 何もしない
      }
    });

    return {
      products,
      DISPLAY_ITEMS_NUM,
      totalDisplayNum,
      pagination,
      isLoadMoreButtonVisible,
      fetchProducts,
    };
  },
});
